
export default{
  tabNum: 0,
  setTabNum(num) {
    this.tabNum = num
  }
}



// WEBPACK FOOTER //
// ./src/global.js